exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** @author: Richard, Need this for new version to not center single item slides */\n.slick-track {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.slick-slider > span {\n  display: block;\n}\n", ""]);

// exports
